import { render, staticRenderFns } from "./RelatorioSinteticoAnaliticoFormacaoSolicitacao.vue?vue&type=template&id=6af6446d&scoped=true"
import script from "./RelatorioSinteticoAnaliticoFormacaoSolicitacao.vue?vue&type=script&lang=js"
export * from "./RelatorioSinteticoAnaliticoFormacaoSolicitacao.vue?vue&type=script&lang=js"
import style0 from "./RelatorioSinteticoAnaliticoFormacaoSolicitacao.vue?vue&type=style&index=0&id=6af6446d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6446d",
  null
  
)

export default component.exports